import DocutaxSubmissionSearchResult from './DocutaxSubmissionSearchResult';

export default class DocutaxSubmissionSearchResultPage {
  /**
   * @type {DocutaxSubmissionSearchResult[]}
   */
  content = [];

  /**
   * @type {number}
   */
  page = 0;

  /**
   * @type {number}
   */
  pageSize = 20;

  /**
   * @type {number}
   */
  totalElements = 0;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.content != null) {
        this.content = opts.content.map(val => new DocutaxSubmissionSearchResult(val));
      }
      if (opts.page != null) {
        this.page = opts.page;
      }
      if (opts.pageSize != null) {
        this.pageSize = opts.pageSize;
      }
      if (opts.totalElements != null) {
        this.totalElements = opts.totalElements;
      }
    }
  }
}
